export default function formatDisplayName(name?: string | null): string {
  if (!name) return '';
  if (name.includes('@')) return name;

  return name.replace(
    /(^|[\s\-'’])(\p{L})/gu,
    (_, separator, letter) => `${separator}${letter.toUpperCase()}`
  );
}
